import * as _ from 'lodash';

export class ClassMapper {
    static fromJSONArray(JSONarray: Array<Object>,classToMap){
        const array = _.map(JSONarray,(a) => {
            return new classToMap(a)
        })
        return array
    }
}